import { FormattedMessage } from 'react-intl';

import { useCurrentUserCurrencies } from 'hooks/useCurrentUserCurrencies';

import type { CreateFiatWalletSteps } from '../../type';
import { Content } from '../Content';

type Props = {
  setStep: (tab: CreateFiatWalletSteps) => void;
  onDismiss?: () => void;
};
export const WhatsNew = (props: Props) => {
  const { cryptocurrencySymbol } = useCurrentUserCurrencies();
  const news = [
    {
      id: 'fiat',
      title: (
        <FormattedMessage
          id="walletSetup.whatsNew.fiat.title"
          defaultMessage="Preferred & flexible currency"
        />
      ),
      desc: (
        <FormattedMessage
          id="walletSetup.whatsNew.fiat.desc2"
          defaultMessage="Buy, sell, and receive rewards in cash. Or choose to use both cash and {cryptocurrencySymbol}."
          values={{
            cryptocurrencySymbol,
          }}
        />
      ),
    },
    {
      id: 'deposit',
      title: (
        <FormattedMessage
          id="walletSetup.whatsNew.deposit.title"
          defaultMessage="Seamless deposits & withdrawals"
        />
      ),
      desc: (
        <FormattedMessage
          id="walletSetup.whatsNew.deposit.desc"
          defaultMessage="Add cash using a credit/debit card, or opt for a bank transfer to easily add or withdraw funds."
        />
      ),
    },
  ];
  return (
    <Content
      {...props}
      news={news}
      title={
        <FormattedMessage
          id="walletSetup.whatsNew.title"
          defaultMessage="Introducing Cash Wallet"
        />
      }
    />
  );
};
